import httpService from "./http.service";

class MetaDataService {
    getMetaData = (key) => {
        return httpService.get(`/app/${key}`);
    };
    setMetaData = (key, data) => {
        return httpService.post(`/app`, { key, data });
    };
}

const metaData = new MetaDataService();
export default metaData;